import {GetSupportLink} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {makeBFFApiUrl} from 'main/factories/http';
import {RemoteGetSupportLink} from 'data/usecases';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetSupportLink = (): GetSupportLink =>
	new RemoteGetSupportLink(
		makeBFFApiUrl(ExternalLinkPoint.support),
		makeAuthorizeHttpClientDecorator(),
	);
